export default __webpack_public_path__ + "static/media/img--design-6.05601e78.jpg";